module.exports = __webpack_public_path__ + "img/product3.2a20076e.png";